import { BaseIcon, Card } from "@dgs/core";
import styled, { css } from "styled-components";

export const Location = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.normal};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	align-self: flex-start;

	${({ theme }) => theme.breakpoints.tablet} {
		font-size: ${({ theme }) => theme.fonts.sizes.large};
	}
`;

export const BaseCard = styled(Card).attrs({ $variant: "outlined" as const })<{
	$isActive?: boolean;
	$hasNoContingent?: boolean;
}>`
	padding: ${({ theme }) => theme.spacing(2)};

	${({ $isActive }) =>
		$isActive &&
		css`
			background: ${({ theme }) => theme.colors.palette.grey[20]};
		`}
	${({ $hasNoContingent }) =>
		$hasNoContingent &&
		css`
			opacity: 0.6;
		`}
    ${({ theme }) => theme.breakpoints.tablet} {
		padding: ${({ theme }) => theme.spacing(5)};
	}
`;

export const Information = styled.div`
	display: grid;
	grid-auto-rows: max-content;
	align-items: center;
	justify-content: start;
`;

export const TravelIcon = styled(BaseIcon)`
	height: 30px;
	width: 30px;
	align-self: center;
	justify-self: center;

	${({ theme }) => theme.breakpoints.tablet} {
		height: 40px;
		width: 40px;
	}
`;
